var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2579 2.625V1.5M14.2124 3.7955L15.0079 3M14.2124 9.75L15.0079 10.5455M8.2579 3.7955L7.4624 3M15.3829 6.75H16.5079",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.25L7.125 13.125",
    stroke: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.20711,
    y: 13.4609,
    width: 12.7339,
    height: 3.05749,
    rx: 1.52875,
    transform: "rotate(-45 2.20711 13.4609)",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.68d61de1d3fac93b4e61e971e4fb238a.svg";
export { ForwardRef as ReactComponent };